import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CrisisBanner } from "@/components/CrisisBanner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingDock } from "@/components/FloatingDock";
import { CursorGlow } from "@/components/CursorGlow";
import { MusicToggle } from "@/components/MusicToggle";
import { AutoTranslate } from "@/components/AutoTranslate";

export const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ block: "start" }), 400);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return (
    <div id="page-root" className="relative min-h-screen flex flex-col bg-bsn-parchment overflow-x-hidden">
      <CursorGlow />
      <CrisisBanner />
      <Navbar />
      <main id="page-main" className="relative z-10 flex-1">{children}</main>
      <AutoTranslate rootId="page-root" />
      <Footer />
      <FloatingDock />
      <MusicToggle />
    </div>
  );
};

export default Layout;
